webpackJsonp([114276838955818,60335399758886],{

/***/ 119:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Walsh Painting Contractors","description":"Master painters and decorators. Walsh Painting Contractors operate near Byron Bay, Northern NSW and specialise in luxury homes and specialised projects.","image":"/wpc-logo-small.png","siteUrl":"https://walshpainting.com.au"}}},"layoutContext":{}}

/***/ }),

/***/ 192:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(205);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(119);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 3:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.BrowserSpriteSymbol = factory());
	}(this, (function () { 'use strict';
	
	var SpriteSymbol = function SpriteSymbol(ref) {
	  var id = ref.id;
	  var viewBox = ref.viewBox;
	  var content = ref.content;
	
	  this.id = id;
	  this.viewBox = viewBox;
	  this.content = content;
	};
	
	/**
	 * @return {string}
	 */
	SpriteSymbol.prototype.stringify = function stringify () {
	  return this.content;
	};
	
	/**
	 * @return {string}
	 */
	SpriteSymbol.prototype.toString = function toString () {
	  return this.stringify();
	};
	
	SpriteSymbol.prototype.destroy = function destroy () {
	    var this$1 = this;
	
	  ['id', 'viewBox', 'content'].forEach(function (prop) { return delete this$1[prop]; });
	};
	
	/**
	 * @param {string} content
	 * @return {Element}
	 */
	var parse = function (content) {
	  var hasImportNode = !!document.importNode;
	  var doc = new DOMParser().parseFromString(content, 'image/svg+xml').documentElement;
	
	  /**
	   * Fix for browser which are throwing WrongDocumentError
	   * if you insert an element which is not part of the document
	   * @see http://stackoverflow.com/a/7986519/4624403
	   */
	  if (hasImportNode) {
	    return document.importNode(doc, true);
	  }
	
	  return doc;
	};
	
	var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	
	
	
	
	
	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}
	
	var deepmerge = createCommonjsModule(function (module, exports) {
	(function (root, factory) {
	    if (false) {
	        undefined(factory);
	    } else {
	        module.exports = factory();
	    }
	}(commonjsGlobal, function () {
	
	function isMergeableObject(val) {
	    var nonNullObject = val && typeof val === 'object';
	
	    return nonNullObject
	        && Object.prototype.toString.call(val) !== '[object RegExp]'
	        && Object.prototype.toString.call(val) !== '[object Date]'
	}
	
	function emptyTarget(val) {
	    return Array.isArray(val) ? [] : {}
	}
	
	function cloneIfNecessary(value, optionsArgument) {
	    var clone = optionsArgument && optionsArgument.clone === true;
	    return (clone && isMergeableObject(value)) ? deepmerge(emptyTarget(value), value, optionsArgument) : value
	}
	
	function defaultArrayMerge(target, source, optionsArgument) {
	    var destination = target.slice();
	    source.forEach(function(e, i) {
	        if (typeof destination[i] === 'undefined') {
	            destination[i] = cloneIfNecessary(e, optionsArgument);
	        } else if (isMergeableObject(e)) {
	            destination[i] = deepmerge(target[i], e, optionsArgument);
	        } else if (target.indexOf(e) === -1) {
	            destination.push(cloneIfNecessary(e, optionsArgument));
	        }
	    });
	    return destination
	}
	
	function mergeObject(target, source, optionsArgument) {
	    var destination = {};
	    if (isMergeableObject(target)) {
	        Object.keys(target).forEach(function (key) {
	            destination[key] = cloneIfNecessary(target[key], optionsArgument);
	        });
	    }
	    Object.keys(source).forEach(function (key) {
	        if (!isMergeableObject(source[key]) || !target[key]) {
	            destination[key] = cloneIfNecessary(source[key], optionsArgument);
	        } else {
	            destination[key] = deepmerge(target[key], source[key], optionsArgument);
	        }
	    });
	    return destination
	}
	
	function deepmerge(target, source, optionsArgument) {
	    var array = Array.isArray(source);
	    var options = optionsArgument || { arrayMerge: defaultArrayMerge };
	    var arrayMerge = options.arrayMerge || defaultArrayMerge;
	
	    if (array) {
	        return Array.isArray(target) ? arrayMerge(target, source, optionsArgument) : cloneIfNecessary(source, optionsArgument)
	    } else {
	        return mergeObject(target, source, optionsArgument)
	    }
	}
	
	deepmerge.all = function deepmergeAll(array, optionsArgument) {
	    if (!Array.isArray(array) || array.length < 2) {
	        throw new Error('first argument should be an array with at least two elements')
	    }
	
	    // we are sure there are at least 2 values, so it is safe to have no initial value
	    return array.reduce(function(prev, next) {
	        return deepmerge(prev, next, optionsArgument)
	    })
	};
	
	return deepmerge
	
	}));
	});
	
	var namespaces_1 = createCommonjsModule(function (module, exports) {
	var namespaces = {
	  svg: {
	    name: 'xmlns',
	    uri: 'http://www.w3.org/2000/svg'
	  },
	  xlink: {
	    name: 'xmlns:xlink',
	    uri: 'http://www.w3.org/1999/xlink'
	  }
	};
	
	exports.default = namespaces;
	module.exports = exports.default;
	});
	
	/**
	 * @param {Object} attrs
	 * @return {string}
	 */
	var objectToAttrsString = function (attrs) {
	  return Object.keys(attrs).map(function (attr) {
	    var value = attrs[attr].toString().replace(/"/g, '&quot;');
	    return (attr + "=\"" + value + "\"");
	  }).join(' ');
	};
	
	var svg = namespaces_1.svg;
	var xlink = namespaces_1.xlink;
	
	var defaultAttrs = {};
	defaultAttrs[svg.name] = svg.uri;
	defaultAttrs[xlink.name] = xlink.uri;
	
	/**
	 * @param {string} [content]
	 * @param {Object} [attributes]
	 * @return {string}
	 */
	var wrapInSvgString = function (content, attributes) {
	  if ( content === void 0 ) content = '';
	
	  var attrs = deepmerge(defaultAttrs, attributes || {});
	  var attrsRendered = objectToAttrsString(attrs);
	  return ("<svg " + attrsRendered + ">" + content + "</svg>");
	};
	
	var BrowserSpriteSymbol = (function (SpriteSymbol$$1) {
	  function BrowserSpriteSymbol () {
	    SpriteSymbol$$1.apply(this, arguments);
	  }
	
	  if ( SpriteSymbol$$1 ) BrowserSpriteSymbol.__proto__ = SpriteSymbol$$1;
	  BrowserSpriteSymbol.prototype = Object.create( SpriteSymbol$$1 && SpriteSymbol$$1.prototype );
	  BrowserSpriteSymbol.prototype.constructor = BrowserSpriteSymbol;
	
	  var prototypeAccessors = { isMounted: {} };
	
	  prototypeAccessors.isMounted.get = function () {
	    return !!this.node;
	  };
	
	  /**
	   * @param {Element} node
	   * @return {BrowserSpriteSymbol}
	   */
	  BrowserSpriteSymbol.createFromExistingNode = function createFromExistingNode (node) {
	    return new BrowserSpriteSymbol({
	      id: node.getAttribute('id'),
	      viewBox: node.getAttribute('viewBox'),
	      content: node.outerHTML
	    });
	  };
	
	  BrowserSpriteSymbol.prototype.destroy = function destroy () {
	    if (this.isMounted) {
	      this.unmount();
	    }
	    SpriteSymbol$$1.prototype.destroy.call(this);
	  };
	
	  /**
	   * @param {Element|string} target
	   * @return {Element}
	   */
	  BrowserSpriteSymbol.prototype.mount = function mount (target) {
	    if (this.isMounted) {
	      return this.node;
	    }
	
	    var mountTarget = typeof target === 'string' ? document.querySelector(target) : target;
	    var node = this.render();
	    this.node = node;
	
	    mountTarget.appendChild(node);
	
	    return node;
	  };
	
	  /**
	   * @return {Element}
	   */
	  BrowserSpriteSymbol.prototype.render = function render () {
	    var content = this.stringify();
	    return parse(wrapInSvgString(content)).childNodes[0];
	  };
	
	  BrowserSpriteSymbol.prototype.unmount = function unmount () {
	    this.node.parentNode.removeChild(this.node);
	  };
	
	  Object.defineProperties( BrowserSpriteSymbol.prototype, prototypeAccessors );
	
	  return BrowserSpriteSymbol;
	}(SpriteSymbol));
	
	return BrowserSpriteSymbol;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 4:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.BrowserSprite = factory());
	}(this, (function () { 'use strict';
	
	var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	
	
	
	
	
	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}
	
	var deepmerge = createCommonjsModule(function (module, exports) {
	(function (root, factory) {
	    if (false) {
	        undefined(factory);
	    } else {
	        module.exports = factory();
	    }
	}(commonjsGlobal, function () {
	
	function isMergeableObject(val) {
	    var nonNullObject = val && typeof val === 'object';
	
	    return nonNullObject
	        && Object.prototype.toString.call(val) !== '[object RegExp]'
	        && Object.prototype.toString.call(val) !== '[object Date]'
	}
	
	function emptyTarget(val) {
	    return Array.isArray(val) ? [] : {}
	}
	
	function cloneIfNecessary(value, optionsArgument) {
	    var clone = optionsArgument && optionsArgument.clone === true;
	    return (clone && isMergeableObject(value)) ? deepmerge(emptyTarget(value), value, optionsArgument) : value
	}
	
	function defaultArrayMerge(target, source, optionsArgument) {
	    var destination = target.slice();
	    source.forEach(function(e, i) {
	        if (typeof destination[i] === 'undefined') {
	            destination[i] = cloneIfNecessary(e, optionsArgument);
	        } else if (isMergeableObject(e)) {
	            destination[i] = deepmerge(target[i], e, optionsArgument);
	        } else if (target.indexOf(e) === -1) {
	            destination.push(cloneIfNecessary(e, optionsArgument));
	        }
	    });
	    return destination
	}
	
	function mergeObject(target, source, optionsArgument) {
	    var destination = {};
	    if (isMergeableObject(target)) {
	        Object.keys(target).forEach(function (key) {
	            destination[key] = cloneIfNecessary(target[key], optionsArgument);
	        });
	    }
	    Object.keys(source).forEach(function (key) {
	        if (!isMergeableObject(source[key]) || !target[key]) {
	            destination[key] = cloneIfNecessary(source[key], optionsArgument);
	        } else {
	            destination[key] = deepmerge(target[key], source[key], optionsArgument);
	        }
	    });
	    return destination
	}
	
	function deepmerge(target, source, optionsArgument) {
	    var array = Array.isArray(source);
	    var options = optionsArgument || { arrayMerge: defaultArrayMerge };
	    var arrayMerge = options.arrayMerge || defaultArrayMerge;
	
	    if (array) {
	        return Array.isArray(target) ? arrayMerge(target, source, optionsArgument) : cloneIfNecessary(source, optionsArgument)
	    } else {
	        return mergeObject(target, source, optionsArgument)
	    }
	}
	
	deepmerge.all = function deepmergeAll(array, optionsArgument) {
	    if (!Array.isArray(array) || array.length < 2) {
	        throw new Error('first argument should be an array with at least two elements')
	    }
	
	    // we are sure there are at least 2 values, so it is safe to have no initial value
	    return array.reduce(function(prev, next) {
	        return deepmerge(prev, next, optionsArgument)
	    })
	};
	
	return deepmerge
	
	}));
	});
	
	//      
	// An event handler can take an optional event argument
	// and should not return a value
	                                          
	// An array of all currently registered event handlers for a type
	                                            
	// A map of event types and their corresponding event handlers.
	                        
	                                   
	  
	
	/** Mitt: Tiny (~200b) functional event emitter / pubsub.
	 *  @name mitt
	 *  @returns {Mitt}
	 */
	function mitt(all                 ) {
		all = all || Object.create(null);
	
		return {
			/**
			 * Register an event handler for the given type.
			 *
			 * @param  {String} type	Type of event to listen for, or `"*"` for all events
			 * @param  {Function} handler Function to call in response to given event
			 * @memberOf mitt
			 */
			on: function on(type        , handler              ) {
				(all[type] || (all[type] = [])).push(handler);
			},
	
			/**
			 * Remove an event handler for the given type.
			 *
			 * @param  {String} type	Type of event to unregister `handler` from, or `"*"`
			 * @param  {Function} handler Handler function to remove
			 * @memberOf mitt
			 */
			off: function off(type        , handler              ) {
				if (all[type]) {
					all[type].splice(all[type].indexOf(handler) >>> 0, 1);
				}
			},
	
			/**
			 * Invoke all handlers for the given type.
			 * If present, `"*"` handlers are invoked after type-matched handlers.
			 *
			 * @param {String} type  The event type to invoke
			 * @param {Any} [evt]  Any value (object is recommended and powerful), passed to each handler
			 * @memberof mitt
			 */
			emit: function emit(type        , evt     ) {
				(all[type] || []).map(function (handler) { handler(evt); });
				(all['*'] || []).map(function (handler) { handler(type, evt); });
			}
		};
	}
	
	var namespaces_1 = createCommonjsModule(function (module, exports) {
	var namespaces = {
	  svg: {
	    name: 'xmlns',
	    uri: 'http://www.w3.org/2000/svg'
	  },
	  xlink: {
	    name: 'xmlns:xlink',
	    uri: 'http://www.w3.org/1999/xlink'
	  }
	};
	
	exports.default = namespaces;
	module.exports = exports.default;
	});
	
	/**
	 * @param {Object} attrs
	 * @return {string}
	 */
	var objectToAttrsString = function (attrs) {
	  return Object.keys(attrs).map(function (attr) {
	    var value = attrs[attr].toString().replace(/"/g, '&quot;');
	    return (attr + "=\"" + value + "\"");
	  }).join(' ');
	};
	
	var svg = namespaces_1.svg;
	var xlink = namespaces_1.xlink;
	
	var defaultAttrs = {};
	defaultAttrs[svg.name] = svg.uri;
	defaultAttrs[xlink.name] = xlink.uri;
	
	/**
	 * @param {string} [content]
	 * @param {Object} [attributes]
	 * @return {string}
	 */
	var wrapInSvgString = function (content, attributes) {
	  if ( content === void 0 ) content = '';
	
	  var attrs = deepmerge(defaultAttrs, attributes || {});
	  var attrsRendered = objectToAttrsString(attrs);
	  return ("<svg " + attrsRendered + ">" + content + "</svg>");
	};
	
	var svg$1 = namespaces_1.svg;
	var xlink$1 = namespaces_1.xlink;
	
	var defaultConfig = {
	  attrs: ( obj = {
	    style: ['position: absolute', 'width: 0', 'height: 0'].join('; ')
	  }, obj[svg$1.name] = svg$1.uri, obj[xlink$1.name] = xlink$1.uri, obj )
	};
	var obj;
	
	var Sprite = function Sprite(config) {
	  this.config = deepmerge(defaultConfig, config || {});
	  this.symbols = [];
	};
	
	/**
	 * Add new symbol. If symbol with the same id exists it will be replaced.
	 * @param {SpriteSymbol} symbol
	 * @return {boolean} `true` - symbol was added, `false` - replaced
	 */
	Sprite.prototype.add = function add (symbol) {
	  var ref = this;
	    var symbols = ref.symbols;
	  var existing = this.find(symbol.id);
	
	  if (existing) {
	    symbols[symbols.indexOf(existing)] = symbol;
	    return false;
	  }
	
	  symbols.push(symbol);
	  return true;
	};
	
	/**
	 * Remove symbol & destroy it
	 * @param {string} id
	 * @return {boolean} `true` - symbol was found & successfully destroyed, `false` - otherwise
	 */
	Sprite.prototype.remove = function remove (id) {
	  var ref = this;
	    var symbols = ref.symbols;
	  var symbol = this.find(id);
	
	  if (symbol) {
	    symbols.splice(symbols.indexOf(symbol), 1);
	    symbol.destroy();
	    return true;
	  }
	
	  return false;
	};
	
	/**
	 * @param {string} id
	 * @return {SpriteSymbol|null}
	 */
	Sprite.prototype.find = function find (id) {
	  return this.symbols.filter(function (s) { return s.id === id; })[0] || null;
	};
	
	/**
	 * @param {string} id
	 * @return {boolean}
	 */
	Sprite.prototype.has = function has (id) {
	  return this.find(id) !== null;
	};
	
	/**
	 * @return {string}
	 */
	Sprite.prototype.stringify = function stringify () {
	  var ref = this.config;
	    var attrs = ref.attrs;
	  var stringifiedSymbols = this.symbols.map(function (s) { return s.stringify(); }).join('');
	  return wrapInSvgString(stringifiedSymbols, attrs);
	};
	
	/**
	 * @return {string}
	 */
	Sprite.prototype.toString = function toString () {
	  return this.stringify();
	};
	
	Sprite.prototype.destroy = function destroy () {
	  this.symbols.forEach(function (s) { return s.destroy(); });
	};
	
	var SpriteSymbol = function SpriteSymbol(ref) {
	  var id = ref.id;
	  var viewBox = ref.viewBox;
	  var content = ref.content;
	
	  this.id = id;
	  this.viewBox = viewBox;
	  this.content = content;
	};
	
	/**
	 * @return {string}
	 */
	SpriteSymbol.prototype.stringify = function stringify () {
	  return this.content;
	};
	
	/**
	 * @return {string}
	 */
	SpriteSymbol.prototype.toString = function toString () {
	  return this.stringify();
	};
	
	SpriteSymbol.prototype.destroy = function destroy () {
	    var this$1 = this;
	
	  ['id', 'viewBox', 'content'].forEach(function (prop) { return delete this$1[prop]; });
	};
	
	/**
	 * @param {string} content
	 * @return {Element}
	 */
	var parse = function (content) {
	  var hasImportNode = !!document.importNode;
	  var doc = new DOMParser().parseFromString(content, 'image/svg+xml').documentElement;
	
	  /**
	   * Fix for browser which are throwing WrongDocumentError
	   * if you insert an element which is not part of the document
	   * @see http://stackoverflow.com/a/7986519/4624403
	   */
	  if (hasImportNode) {
	    return document.importNode(doc, true);
	  }
	
	  return doc;
	};
	
	var BrowserSpriteSymbol = (function (SpriteSymbol$$1) {
	  function BrowserSpriteSymbol () {
	    SpriteSymbol$$1.apply(this, arguments);
	  }
	
	  if ( SpriteSymbol$$1 ) BrowserSpriteSymbol.__proto__ = SpriteSymbol$$1;
	  BrowserSpriteSymbol.prototype = Object.create( SpriteSymbol$$1 && SpriteSymbol$$1.prototype );
	  BrowserSpriteSymbol.prototype.constructor = BrowserSpriteSymbol;
	
	  var prototypeAccessors = { isMounted: {} };
	
	  prototypeAccessors.isMounted.get = function () {
	    return !!this.node;
	  };
	
	  /**
	   * @param {Element} node
	   * @return {BrowserSpriteSymbol}
	   */
	  BrowserSpriteSymbol.createFromExistingNode = function createFromExistingNode (node) {
	    return new BrowserSpriteSymbol({
	      id: node.getAttribute('id'),
	      viewBox: node.getAttribute('viewBox'),
	      content: node.outerHTML
	    });
	  };
	
	  BrowserSpriteSymbol.prototype.destroy = function destroy () {
	    if (this.isMounted) {
	      this.unmount();
	    }
	    SpriteSymbol$$1.prototype.destroy.call(this);
	  };
	
	  /**
	   * @param {Element|string} target
	   * @return {Element}
	   */
	  BrowserSpriteSymbol.prototype.mount = function mount (target) {
	    if (this.isMounted) {
	      return this.node;
	    }
	
	    var mountTarget = typeof target === 'string' ? document.querySelector(target) : target;
	    var node = this.render();
	    this.node = node;
	
	    mountTarget.appendChild(node);
	
	    return node;
	  };
	
	  /**
	   * @return {Element}
	   */
	  BrowserSpriteSymbol.prototype.render = function render () {
	    var content = this.stringify();
	    return parse(wrapInSvgString(content)).childNodes[0];
	  };
	
	  BrowserSpriteSymbol.prototype.unmount = function unmount () {
	    this.node.parentNode.removeChild(this.node);
	  };
	
	  Object.defineProperties( BrowserSpriteSymbol.prototype, prototypeAccessors );
	
	  return BrowserSpriteSymbol;
	}(SpriteSymbol));
	
	var defaultConfig$1 = {
	  /**
	   * Should following options be automatically configured:
	   * - `syncUrlsWithBaseTag`
	   * - `locationChangeAngularEmitter`
	   * - `moveGradientsOutsideSymbol`
	   * @type {boolean}
	   */
	  autoConfigure: true,
	
	  /**
	   * Default mounting selector
	   * @type {string}
	   */
	  mountTo: 'body',
	
	  /**
	   * Fix disappearing SVG elements when <base href> exists.
	   * Executes when sprite mounted.
	   * @see http://stackoverflow.com/a/18265336/796152
	   * @see https://github.com/everdimension/angular-svg-base-fix
	   * @see https://github.com/angular/angular.js/issues/8934#issuecomment-56568466
	   * @type {boolean}
	   */
	  syncUrlsWithBaseTag: false,
	
	  /**
	   * Should sprite listen custom location change event
	   * @type {boolean}
	   */
	  listenLocationChangeEvent: true,
	
	  /**
	   * Custom window event name which should be emitted to update sprite urls
	   * @type {string}
	   */
	  locationChangeEvent: 'locationChange',
	
	  /**
	   * Emit location change event in Angular automatically
	   * @type {boolean}
	   */
	  locationChangeAngularEmitter: false,
	
	  /**
	   * Selector to find symbols usages when updating sprite urls
	   * @type {string}
	   */
	  usagesToUpdate: 'use[*|href]',
	
	  /**
	   * Fix Firefox bug when gradients and patterns don't work if they are within a symbol.
	   * Executes when sprite is rendered, but not mounted.
	   * @see https://bugzilla.mozilla.org/show_bug.cgi?id=306674
	   * @see https://bugzilla.mozilla.org/show_bug.cgi?id=353575
	   * @see https://bugzilla.mozilla.org/show_bug.cgi?id=1235364
	   * @type {boolean}
	   */
	  moveGradientsOutsideSymbol: false
	};
	
	/**
	 * @param {*} arrayLike
	 * @return {Array}
	 */
	var arrayFrom = function (arrayLike) {
	  return Array.prototype.slice.call(arrayLike, 0);
	};
	
	var ua = navigator.userAgent;
	
	var browser = {
	  isChrome: /chrome/i.test(ua),
	  isFirefox: /firefox/i.test(ua),
	
	  // https://msdn.microsoft.com/en-us/library/ms537503(v=vs.85).aspx
	  isIE: /msie/i.test(ua) || /trident/i.test(ua),
	  isEdge: /edge/i.test(ua)
	};
	
	/**
	 * @param {string} name
	 * @param {*} data
	 */
	var dispatchEvent = function (name, data) {
	  var event = document.createEvent('CustomEvent');
	  event.initCustomEvent(name, false, false, data);
	  window.dispatchEvent(event);
	};
	
	/**
	 * IE doesn't evaluate <style> tags in SVGs that are dynamically added to the page.
	 * This trick will trigger IE to read and use any existing SVG <style> tags.
	 * @see https://github.com/iconic/SVGInjector/issues/23
	 * @see https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/10898469/
	 *
	 * @param {Element} node DOM Element to search <style> tags in
	 * @return {Array<HTMLStyleElement>}
	 */
	var evalStylesIEWorkaround = function (node) {
	  var updatedNodes = [];
	
	  arrayFrom(node.querySelectorAll('style'))
	    .forEach(function (style) {
	      style.textContent += '';
	      updatedNodes.push(style);
	    });
	
	  return updatedNodes;
	};
	
	/**
	 * @param {string} [url] If not provided - current URL will be used
	 * @return {string}
	 */
	var getUrlWithoutFragment = function (url) {
	  return (url || window.location.href).split('#')[0];
	};
	
	/* global angular */
	/**
	 * @param {string} eventName
	 */
	var locationChangeAngularEmitter = function (eventName) {
	  angular.module('ng').run(['$rootScope', function ($rootScope) {
	    $rootScope.$on('$locationChangeSuccess', function (e, newUrl, oldUrl) {
	      dispatchEvent(eventName, { oldUrl: oldUrl, newUrl: newUrl });
	    });
	  }]);
	};
	
	var defaultSelector = 'linearGradient, radialGradient, pattern';
	
	/**
	 * @param {Element} svg
	 * @param {string} [selector]
	 * @return {Element}
	 */
	var moveGradientsOutsideSymbol = function (svg, selector) {
	  if ( selector === void 0 ) selector = defaultSelector;
	
	  arrayFrom(svg.querySelectorAll('symbol')).forEach(function (symbol) {
	    arrayFrom(symbol.querySelectorAll(selector)).forEach(function (node) {
	      symbol.parentNode.insertBefore(node, symbol);
	    });
	  });
	  return svg;
	};
	
	/**
	 * @param {NodeList} nodes
	 * @param {Function} [matcher]
	 * @return {Attr[]}
	 */
	function selectAttributes(nodes, matcher) {
	  var attrs = arrayFrom(nodes).reduce(function (acc, node) {
	    if (!node.attributes) {
	      return acc;
	    }
	
	    var arrayfied = arrayFrom(node.attributes);
	    var matched = matcher ? arrayfied.filter(matcher) : arrayfied;
	    return acc.concat(matched);
	  }, []);
	
	  return attrs;
	}
	
	/**
	 * @param {NodeList|Node} nodes
	 * @param {boolean} [clone=true]
	 * @return {string}
	 */
	
	var xLinkNS = namespaces_1.xlink.uri;
	var xLinkAttrName = 'xlink:href';
	
	// eslint-disable-next-line no-useless-escape
	var specialUrlCharsPattern = /[{}|\\\^\[\]`"<>]/g;
	
	function encoder(url) {
	  return url.replace(specialUrlCharsPattern, function (match) {
	    return ("%" + (match[0].charCodeAt(0).toString(16).toUpperCase()));
	  });
	}
	
	/**
	 * @param {NodeList} nodes
	 * @param {string} startsWith
	 * @param {string} replaceWith
	 * @return {NodeList}
	 */
	function updateReferences(nodes, startsWith, replaceWith) {
	  arrayFrom(nodes).forEach(function (node) {
	    var href = node.getAttribute(xLinkAttrName);
	    if (href && href.indexOf(startsWith) === 0) {
	      var newUrl = href.replace(startsWith, replaceWith);
	      node.setAttributeNS(xLinkNS, xLinkAttrName, newUrl);
	    }
	  });
	
	  return nodes;
	}
	
	/**
	 * List of SVG attributes to update url() target in them
	 */
	var attList = [
	  'clipPath',
	  'colorProfile',
	  'src',
	  'cursor',
	  'fill',
	  'filter',
	  'marker',
	  'markerStart',
	  'markerMid',
	  'markerEnd',
	  'mask',
	  'stroke',
	  'style'
	];
	
	var attSelector = attList.map(function (attr) { return ("[" + attr + "]"); }).join(',');
	
	/**
	 * Update URLs in svg image (like `fill="url(...)"`) and update referencing elements
	 * @param {Element} svg
	 * @param {NodeList} references
	 * @param {string|RegExp} startsWith
	 * @param {string} replaceWith
	 * @return {void}
	 *
	 * @example
	 * const sprite = document.querySelector('svg.sprite');
	 * const usages = document.querySelectorAll('use');
	 * updateUrls(sprite, usages, '#', 'prefix#');
	 */
	var updateUrls = function (svg, references, startsWith, replaceWith) {
	  var startsWithEncoded = encoder(startsWith);
	  var replaceWithEncoded = encoder(replaceWith);
	
	  var nodes = svg.querySelectorAll(attSelector);
	  var attrs = selectAttributes(nodes, function (ref) {
	    var localName = ref.localName;
	    var value = ref.value;
	
	    return attList.indexOf(localName) !== -1 && value.indexOf(("url(" + startsWithEncoded)) !== -1;
	  });
	
	  attrs.forEach(function (attr) { return attr.value = attr.value.replace(startsWithEncoded, replaceWithEncoded); });
	  updateReferences(references, startsWithEncoded, replaceWithEncoded);
	};
	
	/**
	 * Internal emitter events
	 * @enum
	 * @private
	 */
	var Events = {
	  MOUNT: 'mount',
	  SYMBOL_MOUNT: 'symbol_mount'
	};
	
	var BrowserSprite = (function (Sprite$$1) {
	  function BrowserSprite(cfg) {
	    var this$1 = this;
	    if ( cfg === void 0 ) cfg = {};
	
	    Sprite$$1.call(this, deepmerge(defaultConfig$1, cfg));
	
	    var emitter = mitt();
	    this._emitter = emitter;
	    this.node = null;
	
	    var ref = this;
	    var config = ref.config;
	
	    if (config.autoConfigure) {
	      this._autoConfigure(cfg);
	    }
	
	    if (config.syncUrlsWithBaseTag) {
	      var baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
	      emitter.on(Events.MOUNT, function () { return this$1.updateUrls('#', baseUrl); });
	    }
	
	    var handleLocationChange = this._handleLocationChange.bind(this);
	    this._handleLocationChange = handleLocationChange;
	
	    // Provide way to update sprite urls externally via dispatching custom window event
	    if (config.listenLocationChangeEvent) {
	      window.addEventListener(config.locationChangeEvent, handleLocationChange);
	    }
	
	    // Emit location change event in Angular automatically
	    if (config.locationChangeAngularEmitter) {
	      locationChangeAngularEmitter(config.locationChangeEvent);
	    }
	
	    // After sprite mounted
	    emitter.on(Events.MOUNT, function (spriteNode) {
	      if (config.moveGradientsOutsideSymbol) {
	        moveGradientsOutsideSymbol(spriteNode);
	      }
	    });
	
	    // After symbol mounted into sprite
	    emitter.on(Events.SYMBOL_MOUNT, function (symbolNode) {
	      if (config.moveGradientsOutsideSymbol) {
	        moveGradientsOutsideSymbol(symbolNode.parentNode);
	      }
	
	      if (browser.isIE || browser.isEdge) {
	        evalStylesIEWorkaround(symbolNode);
	      }
	    });
	  }
	
	  if ( Sprite$$1 ) BrowserSprite.__proto__ = Sprite$$1;
	  BrowserSprite.prototype = Object.create( Sprite$$1 && Sprite$$1.prototype );
	  BrowserSprite.prototype.constructor = BrowserSprite;
	
	  var prototypeAccessors = { isMounted: {} };
	
	  /**
	   * @return {boolean}
	   */
	  prototypeAccessors.isMounted.get = function () {
	    return !!this.node;
	  };
	
	  /**
	   * Automatically configure following options
	   * - `syncUrlsWithBaseTag`
	   * - `locationChangeAngularEmitter`
	   * - `moveGradientsOutsideSymbol`
	   * @param {Object} cfg
	   * @private
	   */
	  BrowserSprite.prototype._autoConfigure = function _autoConfigure (cfg) {
	    var ref = this;
	    var config = ref.config;
	
	    if (typeof cfg.syncUrlsWithBaseTag === 'undefined') {
	      config.syncUrlsWithBaseTag = typeof document.getElementsByTagName('base')[0] !== 'undefined';
	    }
	
	    if (typeof cfg.locationChangeAngularEmitter === 'undefined') {
	      config.locationChangeAngularEmitter = 'angular' in window;
	    }
	
	    if (typeof cfg.moveGradientsOutsideSymbol === 'undefined') {
	      config.moveGradientsOutsideSymbol = browser.isFirefox;
	    }
	  };
	
	  /**
	   * @param {Event} event
	   * @param {Object} event.detail
	   * @param {string} event.detail.oldUrl
	   * @param {string} event.detail.newUrl
	   * @private
	   */
	  BrowserSprite.prototype._handleLocationChange = function _handleLocationChange (event) {
	    var ref = event.detail;
	    var oldUrl = ref.oldUrl;
	    var newUrl = ref.newUrl;
	    this.updateUrls(oldUrl, newUrl);
	  };
	
	  /**
	   * Add new symbol. If symbol with the same id exists it will be replaced.
	   * If sprite already mounted - `symbol.mount(sprite.node)` will be called.
	   * @fires Events#SYMBOL_MOUNT
	   * @param {BrowserSpriteSymbol} symbol
	   * @return {boolean} `true` - symbol was added, `false` - replaced
	   */
	  BrowserSprite.prototype.add = function add (symbol) {
	    var sprite = this;
	    var isNewSymbol = Sprite$$1.prototype.add.call(this, symbol);
	
	    if (this.isMounted && isNewSymbol) {
	      symbol.mount(sprite.node);
	      this._emitter.emit(Events.SYMBOL_MOUNT, symbol.node);
	    }
	
	    return isNewSymbol;
	  };
	
	  /**
	   * Attach to existing DOM node
	   * @param {string|Element} target
	   * @return {Element|null} attached DOM Element. null if node to attach not found.
	   */
	  BrowserSprite.prototype.attach = function attach (target) {
	    var this$1 = this;
	
	    var sprite = this;
	
	    if (sprite.isMounted) {
	      return sprite.node;
	    }
	
	    /** @type Element */
	    var node = typeof target === 'string' ? document.querySelector(target) : target;
	    sprite.node = node;
	
	    // Already added symbols needs to be mounted
	    this.symbols.forEach(function (symbol) {
	      symbol.mount(sprite.node);
	      this$1._emitter.emit(Events.SYMBOL_MOUNT, symbol.node);
	    });
	
	    // Create symbols from existing DOM nodes, add and mount them
	    arrayFrom(node.querySelectorAll('symbol'))
	      .forEach(function (symbolNode) {
	        var symbol = BrowserSpriteSymbol.createFromExistingNode(symbolNode);
	        symbol.node = symbolNode; // hack to prevent symbol mounting to sprite when adding
	        sprite.add(symbol);
	      });
	
	    this._emitter.emit(Events.MOUNT, node);
	
	    return node;
	  };
	
	  BrowserSprite.prototype.destroy = function destroy () {
	    var ref = this;
	    var config = ref.config;
	    var symbols = ref.symbols;
	    var _emitter = ref._emitter;
	
	    symbols.forEach(function (s) { return s.destroy(); });
	
	    _emitter.off('*');
	    window.removeEventListener(config.locationChangeEvent, this._handleLocationChange);
	
	    if (this.isMounted) {
	      this.unmount();
	    }
	  };
	
	  /**
	   * @fires Events#MOUNT
	   * @param {string|Element} [target]
	   * @param {boolean} [prepend=false]
	   * @return {Element|null} rendered sprite node. null if mount node not found.
	   */
	  BrowserSprite.prototype.mount = function mount (target, prepend) {
	    if ( target === void 0 ) target = this.config.mountTo;
	    if ( prepend === void 0 ) prepend = false;
	
	    var sprite = this;
	
	    if (sprite.isMounted) {
	      return sprite.node;
	    }
	
	    var mountNode = typeof target === 'string' ? document.querySelector(target) : target;
	    var node = sprite.render();
	    this.node = node;
	
	    if (prepend && mountNode.childNodes[0]) {
	      mountNode.insertBefore(node, mountNode.childNodes[0]);
	    } else {
	      mountNode.appendChild(node);
	    }
	
	    this._emitter.emit(Events.MOUNT, node);
	
	    return node;
	  };
	
	  /**
	   * @return {Element}
	   */
	  BrowserSprite.prototype.render = function render () {
	    return parse(this.stringify());
	  };
	
	  /**
	   * Detach sprite from the DOM
	   */
	  BrowserSprite.prototype.unmount = function unmount () {
	    this.node.parentNode.removeChild(this.node);
	  };
	
	  /**
	   * Update URLs in sprite and usage elements
	   * @param {string} oldUrl
	   * @param {string} newUrl
	   * @return {boolean} `true` - URLs was updated, `false` - sprite is not mounted
	   */
	  BrowserSprite.prototype.updateUrls = function updateUrls$1 (oldUrl, newUrl) {
	    if (!this.isMounted) {
	      return false;
	    }
	
	    var usages = document.querySelectorAll(this.config.usagesToUpdate);
	
	    updateUrls(
	      this.node,
	      usages,
	      ((getUrlWithoutFragment(oldUrl)) + "#"),
	      ((getUrlWithoutFragment(newUrl)) + "#")
	    );
	
	    return true;
	  };
	
	  Object.defineProperties( BrowserSprite.prototype, prototypeAccessors );
	
	  return BrowserSprite;
	}(Sprite));
	
	var ready$1 = createCommonjsModule(function (module) {
	/*!
	  * domready (c) Dustin Diaz 2014 - License MIT
	  */
	!function (name, definition) {
	
	  { module.exports = definition(); }
	
	}('domready', function () {
	
	  var fns = [], listener
	    , doc = document
	    , hack = doc.documentElement.doScroll
	    , domContentLoaded = 'DOMContentLoaded'
	    , loaded = (hack ? /^loaded|^c/ : /^loaded|^i|^c/).test(doc.readyState);
	
	
	  if (!loaded)
	  { doc.addEventListener(domContentLoaded, listener = function () {
	    doc.removeEventListener(domContentLoaded, listener);
	    loaded = 1;
	    while (listener = fns.shift()) { listener(); }
	  }); }
	
	  return function (fn) {
	    loaded ? setTimeout(fn, 0) : fns.push(fn);
	  }
	
	});
	});
	
	var spriteNodeId = '__SVG_SPRITE_NODE__';
	var spriteGlobalVarName = '__SVG_SPRITE__';
	var isSpriteExists = !!window[spriteGlobalVarName];
	
	// eslint-disable-next-line import/no-mutable-exports
	var sprite;
	
	if (isSpriteExists) {
	  sprite = window[spriteGlobalVarName];
	} else {
	  sprite = new BrowserSprite({ attrs: { id: spriteNodeId } });
	  window[spriteGlobalVarName] = sprite;
	}
	
	var loadSprite = function () {
	  /**
	   * Check for page already contains sprite node
	   * If found - attach to and reuse it's content
	   * If not - render and mount the new sprite
	   */
	  var existing = document.getElementById(spriteNodeId);
	
	  if (existing) {
	    sprite.attach(existing);
	  } else {
	    sprite.mount(document.body, true);
	  }
	};
	
	if (document.body) {
	  loadSprite();
	} else {
	  ready$1(loadSprite);
	}
	
	var sprite$1 = sprite;
	
	return sprite$1;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactEmotion = __webpack_require__(5);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _theme = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HeaderContainer = /*#__PURE__*/(0, _reactEmotion2.default)('header', {
	  target: 'e142sp0s0'
	})('font-size:1.4rem;height:auto;background-color:#fff;border-bottom:', _theme.LINE, ';.logo{height:13rem;padding:1rem;margin-left:-5rem;}@media only screen and (max-width:', _theme.BREAKPOINTS.large, '){.logo{margin-left:-7rem;}}@media only screen and (max-width:', _theme.BREAKPOINTS.medium, '){display:flex;justify-content:center;.logo{height:12rem;margin-left:0;}}');
	
	exports.default = HeaderContainer;
	module.exports = exports['default'];

/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(52);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Header = __webpack_require__(199);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _wpcLogo = __webpack_require__(429);
	
	var _wpcLogo2 = _interopRequireDefault(_wpcLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header(_ref) {
	  var siteTitle = _ref.siteTitle;
	  return _react2.default.createElement(
	    _Header2.default,
	    null,
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: '/' },
	      _react2.default.createElement(
	        'svg',
	        { className: 'logo' },
	        _react2.default.createElement(
	          'title',
	          null,
	          'Logo - Walsh Painting Contractors'
	        ),
	        _react2.default.createElement('use', { xlinkHref: '#' + _wpcLogo2.default.id })
	      )
	    )
	  );
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactEmotion = __webpack_require__(5);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _theme = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SideBarContainer = /*#__PURE__*/(0, _reactEmotion2.default)('nav', {
	  target: 'e1q3v0u10'
	})('background-color:', _theme.COLOURS.greyDark1, ';flex:0 0 18%;display:flex;flex-direction:column;justify-content:space-between;.side-nav{font-size:1.4rem;list-style:none;margin-top:3.5rem;@media only screen and (max-width:', _theme.BREAKPOINTS.medium, '){display:flex;margin:0;}&__item{position:relative;&:not(:last-child){margin-bottom:0.5rem;@media only screen and (max-width:', _theme.BREAKPOINTS.medium, '){margin-bottom:0;}}@media only screen and (max-width:', _theme.BREAKPOINTS.medium, '){flex:1;}}&__link::before{content:\'\';position:absolute;top:0;left:0;height:100%;width:3px;background-color:', _theme.COLOURS.primary, ';z-index:-1;transform:scaleY(0);transition:transform 0.2s,width cubic-bezier(1,0,0,1) 0.4s 0.2s,background-color 0.1s;}&__link:hover::before,&__link--active::before{transform:scaleY(1);width:100%;}&__link:active::before{background-color:', _theme.COLOURS.primaryLight, ';}&__link:link,&__link:visited{color:', _theme.COLOURS.greyLight1, ';text-decoration:none;text-transform:uppercase;display:block;padding:1.5rem 3rem;position:relative;z-index:1;display:flex;align-items:center;@media only screen and (max-width:', _theme.BREAKPOINTS.medium, '){justify-content:center;padding:2rem;}@media only screen and (max-width:', _theme.BREAKPOINTS.small, '){flex-direction:column;padding:1.5rem 0.5rem;}}&__icon{width:1.75rem;height:1.75rem;margin-right:2rem;fill:currentColor;@media only screen and (max-width:', _theme.BREAKPOINTS.small, '){margin-right:0;margin-bottom:.7rem;width:1.5rem;height:1.5rem;}}}.legal{font-size:1.2rem;color:', _theme.COLOURS.greyLight4, ';text-align:center;padding:2.5rem;@media only screen and (max-width:', _theme.BREAKPOINTS.medium, '){display:none;}}');
	
	exports.default = SideBarContainer;
	module.exports = exports['default'];

/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SideBarNav = __webpack_require__(201);
	
	var _SideBarNav2 = _interopRequireDefault(_SideBarNav);
	
	var _gatsbyLink = __webpack_require__(52);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _home = __webpack_require__(26);
	
	var _home2 = _interopRequireDefault(_home);
	
	var _paintFormat = __webpack_require__(28);
	
	var _paintFormat2 = _interopRequireDefault(_paintFormat);
	
	var _newMessage = __webpack_require__(27);
	
	var _newMessage2 = _interopRequireDefault(_newMessage);
	
	var _map = __webpack_require__(428);
	
	var _map2 = _interopRequireDefault(_map);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// use SVG icons with 'gatsby-plugin-svg-sprite' by:
	//<svg className="side-nav__icon">
	//  <use xlinkHref={`#${magnifying_glass.id}`} />
	//</svg>
	
	//ICONS
	var SideNav = function SideNav() {
	  return _react2.default.createElement(
	    _SideBarNav2.default,
	    null,
	    _react2.default.createElement(
	      'ul',
	      { className: 'side-nav' },
	      _react2.default.createElement(
	        'li',
	        { className: 'side-nav__item' },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/about', className: 'side-nav__link', activeClassName: 'side-nav__link--active' },
	          _react2.default.createElement(
	            'svg',
	            { className: 'side-nav__icon' },
	            _react2.default.createElement('use', { xlinkHref: '#' + _home2.default.id })
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            'About'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        { className: 'side-nav__item' },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/work', className: 'side-nav__link', activeClassName: 'side-nav__link--active' },
	          _react2.default.createElement(
	            'svg',
	            { className: 'side-nav__icon' },
	            _react2.default.createElement('use', { xlinkHref: '#' + _paintFormat2.default.id })
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            'Gallery'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        { className: 'side-nav__item' },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/contact', className: 'side-nav__link', activeClassName: 'side-nav__link--active' },
	          _react2.default.createElement(
	            'svg',
	            { className: 'side-nav__icon' },
	            _react2.default.createElement('use', { xlinkHref: '#' + _newMessage2.default.id })
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            'Contact'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'legal' },
	      '\xA9 2018 by Walsh Painting Contractors'
	    )
	  );
	};
	
	exports.default = SideNav;
	module.exports = exports['default'];

/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.MainContent = exports.Content = exports.Container = undefined;
	
	var _reactEmotion = __webpack_require__(5);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _theme = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Container = /*#__PURE__*/exports.Container = (0, _reactEmotion2.default)('div', {
	  target: 'el88qmw0'
	})('max-width:', _theme.CONTAINER.maxWidth, ';margin:8rem auto;background-color:', _theme.COLOURS.greyLight2, ';box-shadow:', _theme.COLOURS.shadowDark, ';height:auto;@media only screen and (max-width:', _theme.BREAKPOINTS.largest, '){margin:0;max-width:100%;width:100%;}');
	
	var Content = /*#__PURE__*/exports.Content = (0, _reactEmotion2.default)('div', {
	  target: 'el88qmw1'
	})('display:flex;height:auto;@media only screen and (max-width:', _theme.BREAKPOINTS.medium, '){flex-direction:column;}');
	
	var MainContent = /*#__PURE__*/exports.MainContent = (0, _reactEmotion2.default)('main', {
	  target: 'el88qmw2'
	})('background-color:#FFF;width:82%;height:auto;@media only screen and (max-width:', _theme.BREAKPOINTS.medium, '){width:100%;}');

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _emotion = __webpack_require__(116);
	
	var _theme = __webpack_require__(6);
	
	//Global normalised standard settings
	var globalStyles = (0, _emotion.injectGlobal)('@import url(\'https://fonts.googleapis.com/css?family=Open+Sans:300,400,600\');*{margin:0;padding:0;}*,*::before,*::after{box-sizing:inherit;}html{box-sizing:border-box;font-size:62.5%;@media only screen and (max-width:', _theme.BREAKPOINTS.large, '){font-size:50%;}}body{font-family:\'Open Sans\',sans-serif;font-weight:400;line-height:1.6;color:', _theme.COLOURS.greyDark2, ';background-image:linear-gradient(to right bottom,', _theme.COLOURS.primaryLight, ',', _theme.COLOURS.primaryDark, ');background-size:cover;background-repeat:no-repeat;min-height:100vh;}');
	
	exports.default = globalStyles;
	module.exports = exports['default'];

/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(55);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _global = __webpack_require__(204);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _components = __webpack_require__(203);
	
	var _Header = __webpack_require__(200);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _SideBarNav = __webpack_require__(202);
	
	var _SideBarNav2 = _interopRequireDefault(_SideBarNav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Layout = function Layout(_ref) {
	  var children = _ref.children,
	      data = _ref.data;
	  return _react2.default.createElement(
	    _components.Container,
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      { title: data.site.siteMetadata.title },
	      _react2.default.createElement('meta', { name: 'description', content: data.site.siteMetadata.description }),
	      _react2.default.createElement('meta', { name: 'image', content: data.site.siteMetadata.image }),
	      _react2.default.createElement('meta', { property: 'og:url', content: data.site.siteMetadata.siteUrl }),
	      _react2.default.createElement('meta', { property: 'og:title', content: data.site.siteMetadata.title }),
	      _react2.default.createElement('meta', { property: 'og:description', content: data.site.siteMetadata.description })
	    ),
	    _react2.default.createElement(_Header2.default, { siteTitle: data.site.siteMetadata.title }),
	    _react2.default.createElement(
	      _components.Content,
	      null,
	      _react2.default.createElement(_SideBarNav2.default, null),
	      _react2.default.createElement(
	        _components.MainContent,
	        null,
	        children()
	      )
	    )
	  );
	};
	
	Layout.propTypes = {
	  children: _propTypes2.default.func
	};
	
	exports.default = Layout;
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 26:
/***/ (function(module, exports, __webpack_require__) {

	var SpriteSymbol = __webpack_require__(3);
	var sprite = __webpack_require__(4);
	var symbol = new SpriteSymbol({
	  "id": "home",
	  "use": "home-usage",
	  "viewBox": "0 0 20 20",
	  "content": "<symbol viewBox=\"0 0 20 20\" id=\"home\">\n<title>home</title>\n<path d=\"M18.672 11h-1.672v6c0 0.445-0.194 1-1 1h-4v-6h-4v6h-4c-0.806 0-1-0.555-1-1v-6h-1.672c-0.598 0-0.47-0.324-0.060-0.748l8.024-8.032c0.195-0.202 0.451-0.302 0.708-0.312 0.257 0.010 0.513 0.109 0.708 0.312l8.023 8.031c0.411 0.425 0.539 0.749-0.059 0.749z\" />\n</symbol>"
	});
	var result = sprite.add(symbol);
	module.exports = symbol

/***/ }),

/***/ 428:
/***/ (function(module, exports, __webpack_require__) {

	var SpriteSymbol = __webpack_require__(3);
	var sprite = __webpack_require__(4);
	var symbol = new SpriteSymbol({
	  "id": "map",
	  "use": "map-usage",
	  "viewBox": "0 0 20 20",
	  "content": "<symbol viewBox=\"0 0 20 20\" id=\"map\">\n<title>map</title>\n<path d=\"M19.447 3.718l-6-3c-0.281-0.141-0.613-0.141-0.895 0l-5.63 2.815-5.606-1.869c-0.306-0.102-0.64-0.051-0.901 0.138s-0.415 0.49-0.415 0.811v13.001c0 0.379 0.214 0.725 0.553 0.894l6 3c0.141 0.070 0.294 0.106 0.447 0.106s0.307-0.035 0.447-0.106l5.63-2.814 5.606 1.869c0.305 0.1 0.64 0.049 0.901-0.139s0.415-0.49 0.415-0.81v-13.002c0.001-0.379-0.213-0.725-0.552-0.894zM8 5.231l4-2v11.763l-4 2v-11.763zM2 4l4 1.333v11.661l-4-2v-10.994zM18 16.227l-4-1.334v-11.662l4 2v10.996z\" />\n</symbol>"
	});
	var result = sprite.add(symbol);
	module.exports = symbol

/***/ }),

/***/ 27:
/***/ (function(module, exports, __webpack_require__) {

	var SpriteSymbol = __webpack_require__(3);
	var sprite = __webpack_require__(4);
	var symbol = new SpriteSymbol({
	  "id": "new-message",
	  "use": "new-message-usage",
	  "viewBox": "0 0 20 20",
	  "content": "<symbol viewBox=\"0 0 20 20\" id=\"new-message\">\n<title>new-message</title>\n<path d=\"M18.174 1.826c-1.102-1.102-2.082-0.777-2.082-0.777l-8.639 8.632-1.453 4.319 4.317-1.454 8.634-8.638c0 0 0.324-0.98-0.777-2.082zM10.605 11.605l-0.471 0.47-1.473 0.5c-0.104-0.24-0.234-0.477-0.498-0.74s-0.5-0.394-0.74-0.498l0.5-1.473 0.471-0.47c0 0 0.776-0.089 1.537 0.673 0.762 0.761 0.674 1.538 0.674 1.538zM16 17h-13v-13h5l2-2h-7c-1.1 0-2 0.9-2 2v13c0 1.1 0.9 2 2 2h13c1.1 0 2-0.9 2-2v-7l-2 2v5z\" />\n</symbol>"
	});
	var result = sprite.add(symbol);
	module.exports = symbol

/***/ }),

/***/ 28:
/***/ (function(module, exports, __webpack_require__) {

	var SpriteSymbol = __webpack_require__(3);
	var sprite = __webpack_require__(4);
	var symbol = new SpriteSymbol({
	  "id": "paint-format",
	  "use": "paint-format-usage",
	  "viewBox": "0 0 32 32",
	  "content": "<symbol viewBox=\"0 0 32 32\" id=\"paint-format\">\n<title>paint-format</title>\n<path d=\"M32 18v-12h-6v-2c0-1.1-0.9-2-2-2h-22c-1.1 0-2 0.9-2 2v6c0 1.1 0.9 2 2 2h22c1.1 0 2-0.9 2-2v-2h4v8h-18v4h-1c-0.552 0-1 0.448-1 1v10c0 0.552 0.448 1 1 1h4c0.552 0 1-0.448 1-1v-10c0-0.552-0.448-1-1-1h-1v-2h18zM24 6h-22v-2h22v2z\" />\n</symbol>"
	});
	var result = sprite.add(symbol);
	module.exports = symbol

/***/ }),

/***/ 429:
/***/ (function(module, exports, __webpack_require__) {

	var SpriteSymbol = __webpack_require__(3);
	var sprite = __webpack_require__(4);
	var symbol = new SpriteSymbol({
	  "id": "wpc-logo",
	  "use": "wpc-logo-usage",
	  "viewBox": "0 0 264.6 162.4",
	  "content": "<symbol viewBox=\"0 0 264.6 162.4\" id=\"wpc-logo\">\n<style type=\"text/css\">\n\t#wpc-logo .st0{fill:#2474A9;}\n\t#wpc-logo .st1{fill:#585A5C;}\n</style>\n<g>\n\t<g>\n\t\t<g>\n\t\t\t<g>\n\t\t\t\t<path class=\"st0\" d=\"M101.2,146.7v-7.2h-8.8v7.2H89v-17.8h3.4v7.5h8.8v-7.5h3.3v17.8H101.2z\" />\n\t\t\t\t<path class=\"st0\" d=\"M54.3,128.9v14.7h9.2v3.1H51v-17.8H54.3z\" />\n\t\t\t\t<path class=\"st0\" d=\"M80.5,132.8c-0.6-1-2.3-2-4.2-2c-2.5,0-3.7,1-3.7,2.4c0,1.6,1.8,2,4,2.2c3.7,0.5,7.2,1.4,7.2,5.7\n\t\t\t\t\tc0,4-3.5,5.7-7.5,5.7c-3.6,0-6.4-1.1-7.8-4.4l2.8-1.5c0.8,2,2.8,2.8,5,2.8c2.1,0,4.1-0.7,4.1-2.7c0-1.7-1.8-2.4-4.1-2.6\n\t\t\t\t\tc-3.6-0.4-7-1.4-7-5.4c0-3.7,3.6-5.2,6.9-5.2c2.8,0,5.6,0.8,7,3.5L80.5,132.8z\" />\n\t\t\t\t<path class=\"st0\" d=\"M20.3,146.7h-2.8l-2.2-5.6l-1.9-5.6l-1.9,5.7l-2.2,5.5H6.5L0,128.9h3.8L8,141.7l4.3-12.8h2.2l4.5,12.8\n\t\t\t\t\tl4.1-12.8h3.8L20.3,146.7z\" />\n\t\t\t\t<polygon class=\"st0\" points=\"42,146.7 45.7,146.7 37.7,128.9 34.1,128.9 26.1,146.7 29.7,146.7 35.9,132.7 \t\t\t\t\" />\n\t\t\t</g>\n\t\t\t<g>\n\t\t\t\t<path class=\"st0\" d=\"M262.1,132.9c-1.2-1.1-3-1.8-4.5-1.8c-3.8,0-6.1,2.9-6.1,6.6c0,2.9,1.7,6,6.1,6c1.4,0,2.6-0.3,4-1.4v-3.2\n\t\t\t\t\tH257v-3h7.6v7.5c-1.8,2-4,3.2-7.1,3.2c-6.7,0-9.4-4.4-9.4-9.1c0-5,3.1-9.6,9.4-9.6c2.4,0,4.8,0.9,6.6,2.7L262.1,132.9z\" />\n\t\t\t\t<path class=\"st0\" d=\"M217.3,146.7v-17.8h3.3v17.8H217.3z\" />\n\t\t\t\t<path class=\"st0\" d=\"M165.4,146.7v-17.8h3.3v17.8H165.4z\" />\n\t\t\t\t<path class=\"st0\" d=\"M186.2,128.9h3.4v17.8h-2.1l0,0l-9.4-12v12h-3.4v-17.8h2.7l8.7,11v-11H186.2z\" />\n\t\t\t\t<path class=\"st0\" d=\"M238.6,128.9h3.4v17.8h-2.1l0,0l-9.4-12v12h-3.4v-17.8h2.7l8.7,11L238.6,128.9L238.6,128.9z\" />\n\t\t\t\t<path class=\"st0\" d=\"M201.4,132h-5.6v-3.1c5.1,0,9.5,0,14.7,0v3.1h-5.6v14.8h-3.4V132H201.4z\" />\n\t\t\t\t<polygon class=\"st0\" points=\"156.3,146.7 159.9,146.7 151.9,128.9 148.3,128.9 140.3,146.7 143.9,146.7 150.1,132.7 \t\t\t\t\" />\n\t\t\t\t<path class=\"st0\" d=\"M132.6,128.9c-2.8,0-5.6,0-8.4,0v3.2h3.4h1.5h3.5c4.3,0,4.3,6.3,0,6.3h-3.7h-1.3h-3.4v8.3h3.4v-5.2h5\n\t\t\t\t\tC141.3,141.5,141.3,128.9,132.6,128.9z\" />\n\t\t\t</g>\n\t\t</g>\n\t\t<g>\n\t\t\t<path class=\"st0\" d=\"M177.3,95.7c-2.3,2.3-5.8,3.6-8.9,3.6c-7.4,0-11-4.3-11.9-9.2c-0.5,0.9-1.1,1.7-1.8,2.4\n\t\t\t\tc-1,1.1-2.2,2-3.6,2.7c2.5,5.9,8,10.4,17.2,10.4c5.1,0,9.8-1.7,13.5-5.3L177.3,95.7z\" />\n\t\t\t<path class=\"st0\" d=\"M133.4,76.4h3h7.1c2.7,0,4.6,1.3,5.5,3c0.8-2.3,2.1-4.3,3.6-6.1c-2.2-2-5.2-3.3-9.1-3.3\n\t\t\t\tc-5.6,0-11.2,0.1-16.7,0.1h-4.1l-8.1,25.6l-8.9-25.6h-4.4l-8.6,25.6l-8.4-25.6h-7.5l13,35.5h5.7l4.3-11.1l3.7-11.3l3.8,11.2\n\t\t\t\tl4.4,11.2h5.7l10.5-29.2L133.4,76.4L133.4,76.4z\" />\n\t\t\t<path class=\"st0\" d=\"M156.3,85L156.3,85c0.8-5.2,4.6-10,12.1-10c3.1,0,6.2,1.1,8.6,3.3l4.5-4.3c-3.7-3.6-8.2-5.4-13-5.4\n\t\t\t\tc-11.1,0-17.1,7.1-18.5,15l0,0c-0.3,2.9-2.4,5.5-6.3,5.5h-7.5h-2.6h-6.7v16.6h6.7V95.2h10C151.1,95.2,155.4,90.4,156.3,85z\" />\n\t\t</g>\n\t\t<g>\n\t\t\t<g>\n\t\t\t\t<g>\n\t\t\t\t\t<polygon class=\"st0\" points=\"160.6,56.2 164,59.6 178.2,45.4 174.9,42.1 \t\t\t\t\t\" />\n\t\t\t\t\t<path class=\"st0\" d=\"M166,61.3l4.6,4.6c0,0,4.8,4.8,10.4-1.1c0.9,0.5,1.6,0.8,2.5,2.7s7.3,14.9,13,9.8c0.8-1.2,2-3.9-2-7.1\n\t\t\t\t\t\ts-4.6-3.3-7.8-5.3c-2.2-1.3-3-2.1-2.4-3.1s5.9-4.6,1.3-9.1c-3.9-3.9-5.5-5.5-5.5-5.5L166,61.3z\" />\n\t\t\t\t</g>\n\t\t\t\t<path class=\"st0\" d=\"M162.7,50l-27-27l-4.1-4.1l-4.1,4.1L88.4,62.1c-1.1,1.1-1.1,3,0,4.1s3,1.1,4.1,0l39.1-39.1l27,27L162.7,50z\n\t\t\t\t\t\" />\n\t\t\t\t<path class=\"st0\" d=\"M167.7,44.9l-32.1-32.1l-4.1-4.1l-4.1,4.1L90.7,49.5c-1.1,1.1-1.1,3,0,4.1s3,1.1,4.1,0l36.7-36.7L163.6,49\n\t\t\t\t\tL167.7,44.9z\" />\n\t\t\t\t<path class=\"st0\" d=\"M172.8,39.9L133.7,0.8c-1.1-1.1-3-1.1-4.1,0L67.2,63.2c-1.1,1.1-1.1,3,0,4.1c1.1,1.1,3,1.1,4.1,0l60.4-60.4\n\t\t\t\t\tL168.8,44L172.8,39.9z\" />\n\t\t\t</g>\n\t\t</g>\n\t</g>\n\t<g>\n\t\t<g>\n\t\t\t<g>\n\t\t\t\t<g>\n\t\t\t\t\t<path class=\"st1\" d=\"M65.9,161.1c-1.1,1-2.4,1.5-3.9,1.5c-3.8,0-5.4-2.6-5.4-5.3s1.7-5.4,5.4-5.4c1.4,0,2.7,0.5,3.8,1.6\n\t\t\t\t\t\tl-1.3,1.2c-0.7-0.7-1.6-1-2.5-1c-2.5,0-3.5,1.8-3.5,3.5c0,1.7,1,3.5,3.5,3.5c0.9,0,1.9-0.4,2.6-1L65.9,161.1z\" />\n\t\t\t\t\t<path class=\"st1\" d=\"M81.1,157.4c0,2.6-1.7,5.3-5.2,5.3c-3.6,0-5.3-2.6-5.3-5.3c0-2.7,1.7-5.4,5.3-5.4\n\t\t\t\t\t\tC79.4,152,81.2,154.7,81.1,157.4z M72.5,157.4c0,1.7,0.9,3.5,3.4,3.5c2.4,0,3.3-1.8,3.3-3.5c0-1.7-0.9-3.7-3.3-3.7\n\t\t\t\t\t\tC73.5,153.7,72.5,155.7,72.5,157.4z\" />\n\t\t\t\t\t<path class=\"st1\" d=\"M93.4,152.2h1.9v10.2h-1.2l0,0l-5.4-6.9v6.9h-1.9v-10.2h1.6l5,6.3L93.4,152.2L93.4,152.2z\" />\n\t\t\t\t\t<path class=\"st1\" d=\"M103.8,153.9h-3.2v-1.8c3,0,5.4,0,8.4,0v1.8h-3.2v8.5h-1.9v-8.5H103.8z\" />\n\t\t\t\t\t<path class=\"st1\" d=\"M123.3,162.4H121l-3-3.4h-1.9v3.4h-1.9v-10.2c1.6,0,3.2,0,4.9,0c2.4,0,3.7,1.6,3.7,3.4\n\t\t\t\t\t\tc0,1.4-0.6,2.8-2.6,3.2l3.1,3.5V162.4z M116.2,154v3.3h2.9c1.2,0,1.8-0.8,1.8-1.6s-0.5-1.6-1.8-1.6L116.2,154L116.2,154z\" />\n\t\t\t\t\t<path class=\"st1\" d=\"M135.4,160.5h-5.3l-0.9,1.9h-2.1l4.6-10.2h2.1l4.6,10.2h-2.1L135.4,160.5z M132.8,154.3l-1.9,4.4h3.8\n\t\t\t\t\t\tL132.8,154.3z\" />\n\t\t\t\t\t<path class=\"st1\" d=\"M151.8,161.1c-1.1,1-2.4,1.5-3.9,1.5c-3.8,0-5.4-2.6-5.4-5.3s1.7-5.4,5.4-5.4c1.4,0,2.7,0.5,3.8,1.6\n\t\t\t\t\t\tl-1.3,1.2c-0.7-0.7-1.6-1-2.5-1c-2.5,0-3.5,1.8-3.5,3.5c0,1.7,1,3.5,3.5,3.5c0.9,0,1.9-0.4,2.6-1L151.8,161.1z\" />\n\t\t\t\t\t<path class=\"st1\" d=\"M159.4,153.9h-3.2v-1.8c3,0,5.4,0,8.4,0v1.8h-3.2v8.5h-1.9v-8.5H159.4z\" />\n\t\t\t\t\t<path class=\"st1\" d=\"M179.9,157.4c0,2.6-1.7,5.3-5.2,5.3c-3.6,0-5.3-2.6-5.3-5.3c0-2.7,1.7-5.4,5.3-5.4\n\t\t\t\t\t\tC178.2,152,179.9,154.7,179.9,157.4z M171.3,157.4c0,1.7,0.9,3.5,3.4,3.5c2.4,0,3.3-1.8,3.3-3.5c0-1.7-0.9-3.7-3.3-3.7\n\t\t\t\t\t\tC172.3,153.7,171.3,155.7,171.3,157.4z\" />\n\t\t\t\t\t<path class=\"st1\" d=\"M194.5,162.4h-2.3l-3-3.4h-1.9v3.4h-1.9v-10.2c1.6,0,3.2,0,4.9,0c2.4,0,3.7,1.6,3.7,3.4\n\t\t\t\t\t\tc0,1.4-0.6,2.8-2.6,3.2l3.1,3.5V162.4z M187.4,154v3.3h2.9c1.2,0,1.8-0.8,1.8-1.6s-0.5-1.6-1.8-1.6L187.4,154L187.4,154z\" />\n\t\t\t\t\t<path class=\"st1\" d=\"M206.1,154.7c-0.4-0.6-1.3-1.1-2.4-1.1c-1.4,0-2.1,0.6-2.1,1.4c0,0.9,1.1,1.1,2.3,1.3\n\t\t\t\t\t\tc2.1,0.3,4.1,0.8,4.1,3.3c0,2.3-2,3.3-4.3,3.3c-2.1,0-3.7-0.6-4.5-2.5l1.6-0.8c0.5,1.1,1.6,1.6,2.9,1.6c1.2,0,2.4-0.4,2.4-1.5\n\t\t\t\t\t\tc0-1-1-1.4-2.4-1.5c-2.1-0.2-4-0.8-4-3.1c0-2.1,2.1-3,4-3c1.6,0,3.2,0.5,4,2L206.1,154.7z\" />\n\t\t\t\t</g>\n\t\t\t</g>\n\t\t\t<rect x=\"0\" y=\"156.8\" class=\"st1\" width=\"49.8\" height=\"1.2\" />\n\t\t\t<rect x=\"214.8\" y=\"156.8\" class=\"st1\" width=\"49.8\" height=\"1.2\" />\n\t\t</g>\n\t\t<g>\n\t\t\t<polygon class=\"st1\" points=\"103.9,60.4 131.6,32.7 159.3,60.4 162.5,60.4 131.6,29.5 100.7,60.4 \t\t\t\" />\n\t\t\t<g>\n\t\t\t\t<rect x=\"123.3\" y=\"44.2\" class=\"st1\" width=\"7\" height=\"7\" />\n\t\t\t\t<rect x=\"132.8\" y=\"44.2\" class=\"st1\" width=\"7\" height=\"7\" />\n\t\t\t\t<rect x=\"123.3\" y=\"53.3\" class=\"st1\" width=\"7\" height=\"7\" />\n\t\t\t\t<rect x=\"132.8\" y=\"53.3\" class=\"st1\" width=\"7\" height=\"7\" />\n\t\t\t</g>\n\t\t</g>\n\t\t<path class=\"st1\" d=\"M194.5,115.3L194.5,115.3c0-2.1-1.7-3.7-3.7-3.7H72.9c-2.1,0-3.7,1.7-3.7,3.7l0,0l0,0l0,0\n\t\t\tc0,2.1,1.7,3.7,3.7,3.7h117.8C192.8,119.1,194.5,117.4,194.5,115.3L194.5,115.3\" />\n\t</g>\n</g>\n</symbol>"
	});
	var result = sprite.add(symbol);
	module.exports = symbol

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-016ba5b08d6e88485fe6.js